import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import * as fileSaver from 'file-saver';

import { TranscriptionService } from './../../../core/services/transcription.service';
import { ModalNotificationComponent } from '../modal-notification/modal-notification.component';
import { GlobalComponents } from '../global-constants';
import { Language } from 'src/app/models/languageModel/language';

@Component({
  selector: 'app-modal-downloadWord',
  templateUrl: './modal-download-word.component.html',
  styleUrls: ['./modal-download-word.component.scss']
})

export class ModalDownloadWordComponent implements OnInit {

  @Input() meetingId:number;
  @Input() languageId:number;
  @Output() finishDownloadStatus = new EventEmitter<boolean>();

  constructor(private dialog: MatDialog,
              public dialogRef: MatDialogRef<ModalDownloadWordComponent>,
              public datepipe: DatePipe,
              public transcriptionService: TranscriptionService) { }

  ngOnInit(): void {
  }

  closeModal()
  {
    this.dialogRef.close(false);
  }

  handlerDownload(){
    let currentLanguage: Language = JSON.parse(localStorage.getItem('languaje'));
    if(currentLanguage.code == "es"){
      this.languageId = 1;
    }
    else{
      this.languageId = 2;
    }
    
    this.transcriptionService.getWord(this.meetingId, this.languageId).toPromise()
    .then((response) => {

      let tm = "";
      if(this.languageId == 1){
        tm = "_TranscripciónDeReunión_";
      }
      else{
        tm = "_MeetingTranscription_";
      }

      const blob = new Blob([response], { type: response.type });
      fileSaver.saveAs(blob, this.datepipe.transform(Date.now(), 'yyyyMMddHHmmss') + tm + this.meetingId + ".docx")
      this.finishDownloadStatus.emit(false);
  
      this.dialog.closeAll();
    }, (error) => {
      this.notificationModal(GlobalComponents.notSuccess);
    });
  }

  notificationModal(message: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      message: message,
      valor: 10
    }
    const modalRef = this.dialog.open(ModalNotificationComponent, dialogConfig);
  }
  
}
